var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgGraphicLines = function SvgGraphicLines(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1180,
    height: 674,
    viewBox: "0 0 1180 674",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5579_16003)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M663.254 -34.9798L501.894 692.247",
    strokeWidth: 3.52,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.52 -34.9798L443.16 692.247",
    strokeWidth: 3.52,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.786 -34.9798L384.413 692.247",
    strokeWidth: 3.52,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.04 -34.9798L325.68 692.247",
    strokeWidth: 3.52,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.306 -34.9798L266.946 692.247",
    strokeWidth: 3.52,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.573 -34.9798L208.213 692.247",
    strokeWidth: 3.52,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.827 -34.9798L149.467 692.247",
    strokeWidth: 3.52,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.093 -34.9798L90.7334 692.247",
    strokeWidth: 3.52,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.36 -34.9798L32 692.247",
    strokeWidth: 3.52,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.48 227.097H592.12L650.44 -35.7656H676.8L618.48 227.097Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.734 227.097H533.374L591.707 -35.7656H618.067L559.734 227.097Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.001 227.097H474.641L532.961 -35.7656H559.321L501.001 227.097Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.267 227.097H415.907L474.227 -35.7656H500.587L442.267 227.097Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.52 227.097H357.16L415.493 -35.7656H441.853L383.52 227.097Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.787 227.097H298.427L356.76 -35.7656H383.12L324.787 227.097Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.054 227.097H239.694L298.014 -35.7656H324.374L266.054 227.097Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.321 227.097H180.961L239.281 -35.7656H265.641L207.321 227.097Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.574 227.097H122.214L180.547 -35.7656H206.907L148.574 227.097Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1130.31 227.096L968.945 954.31",
    strokeWidth: 3.52,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1071.57 227.096L910.212 954.31",
    strokeWidth: 3.52,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1012.84 227.096L851.479 954.31",
    strokeWidth: 3.52,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M954.105 227.096L792.731 954.31",
    strokeWidth: 3.52,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M895.358 227.096L733.998 954.31",
    strokeWidth: 3.52,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M836.625 227.096L675.265 954.31",
    strokeWidth: 3.52,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M777.892 227.096L616.519 954.31",
    strokeWidth: 3.52,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M719.145 227.096L557.785 954.31",
    strokeWidth: 3.52,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.412 227.096L499.052 954.31",
    strokeWidth: 3.52,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1089.03 485.948H1062.67L1120.99 223.086H1147.35L1089.03 485.948Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1030.28 485.948H1003.92L1062.25 223.086H1088.61L1030.28 485.948Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M971.546 485.948H945.186L1003.52 223.086H1029.88L971.546 485.948Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M912.812 485.948H886.452L944.772 223.086H971.132L912.812 485.948Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M854.079 485.948H827.719L886.039 223.086H912.399L854.079 485.948Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M795.333 485.948H768.973L827.306 223.086H853.666L795.333 485.948Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M736.599 485.948H710.239L768.559 223.086H794.919L736.599 485.948Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M677.866 485.948H651.506L709.826 223.086H736.186L677.866 485.948Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.119 485.948H592.772L651.092 223.086H677.452L619.119 485.948Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5579_16003"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1180,
    height: 674,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgGraphicLines);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTE4MCIgaGVpZ2h0PSI2NzQiIHZpZXdCb3g9IjAgMCAxMTgwIDY3NCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzU1NzlfMTYwMDMpIj4KPHBhdGggZD0iTTY2My4yNTQgLTM0Ljk3OThMNTAxLjg5NCA2OTIuMjQ3IiBzdHJva2Utd2lkdGg9IjMuNTIiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIvPgo8cGF0aCBkPSJNNjA0LjUyIC0zNC45Nzk4TDQ0My4xNiA2OTIuMjQ3IiBzdHJva2Utd2lkdGg9IjMuNTIiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIvPgo8cGF0aCBkPSJNNTQ1Ljc4NiAtMzQuOTc5OEwzODQuNDEzIDY5Mi4yNDciIHN0cm9rZS13aWR0aD0iMy41MiIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIi8+CjxwYXRoIGQ9Ik00ODcuMDQgLTM0Ljk3OThMMzI1LjY4IDY5Mi4yNDciIHN0cm9rZS13aWR0aD0iMy41MiIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIi8+CjxwYXRoIGQ9Ik00MjguMzA2IC0zNC45Nzk4TDI2Ni45NDYgNjkyLjI0NyIgc3Ryb2tlLXdpZHRoPSIzLjUyIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiLz4KPHBhdGggZD0iTTM2OS41NzMgLTM0Ljk3OThMMjA4LjIxMyA2OTIuMjQ3IiBzdHJva2Utd2lkdGg9IjMuNTIiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIvPgo8cGF0aCBkPSJNMzEwLjgyNyAtMzQuOTc5OEwxNDkuNDY3IDY5Mi4yNDciIHN0cm9rZS13aWR0aD0iMy41MiIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIi8+CjxwYXRoIGQ9Ik0yNTIuMDkzIC0zNC45Nzk4TDkwLjczMzQgNjkyLjI0NyIgc3Ryb2tlLXdpZHRoPSIzLjUyIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiLz4KPHBhdGggZD0iTTE5My4zNiAtMzQuOTc5OEwzMiA2OTIuMjQ3IiBzdHJva2Utd2lkdGg9IjMuNTIiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIvPgo8cGF0aCBkPSJNNjE4LjQ4IDIyNy4wOTdINTkyLjEyTDY1MC40NCAtMzUuNzY1Nkg2NzYuOEw2MTguNDggMjI3LjA5N1oiLz4KPHBhdGggZD0iTTU1OS43MzQgMjI3LjA5N0g1MzMuMzc0TDU5MS43MDcgLTM1Ljc2NTZINjE4LjA2N0w1NTkuNzM0IDIyNy4wOTdaIi8+CjxwYXRoIGQ9Ik01MDEuMDAxIDIyNy4wOTdINDc0LjY0MUw1MzIuOTYxIC0zNS43NjU2SDU1OS4zMjFMNTAxLjAwMSAyMjcuMDk3WiIvPgo8cGF0aCBkPSJNNDQyLjI2NyAyMjcuMDk3SDQxNS45MDdMNDc0LjIyNyAtMzUuNzY1Nkg1MDAuNTg3TDQ0Mi4yNjcgMjI3LjA5N1oiLz4KPHBhdGggZD0iTTM4My41MiAyMjcuMDk3SDM1Ny4xNkw0MTUuNDkzIC0zNS43NjU2SDQ0MS44NTNMMzgzLjUyIDIyNy4wOTdaIi8+CjxwYXRoIGQ9Ik0zMjQuNzg3IDIyNy4wOTdIMjk4LjQyN0wzNTYuNzYgLTM1Ljc2NTZIMzgzLjEyTDMyNC43ODcgMjI3LjA5N1oiLz4KPHBhdGggZD0iTTI2Ni4wNTQgMjI3LjA5N0gyMzkuNjk0TDI5OC4wMTQgLTM1Ljc2NTZIMzI0LjM3NEwyNjYuMDU0IDIyNy4wOTdaIi8+CjxwYXRoIGQ9Ik0yMDcuMzIxIDIyNy4wOTdIMTgwLjk2MUwyMzkuMjgxIC0zNS43NjU2SDI2NS42NDFMMjA3LjMyMSAyMjcuMDk3WiIvPgo8cGF0aCBkPSJNMTQ4LjU3NCAyMjcuMDk3SDEyMi4yMTRMMTgwLjU0NyAtMzUuNzY1NkgyMDYuOTA3TDE0OC41NzQgMjI3LjA5N1oiLz4KPHBhdGggZD0iTTExMzAuMzEgMjI3LjA5Nkw5NjguOTQ1IDk1NC4zMSIgc3Ryb2tlLXdpZHRoPSIzLjUyIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiLz4KPHBhdGggZD0iTTEwNzEuNTcgMjI3LjA5Nkw5MTAuMjEyIDk1NC4zMSIgc3Ryb2tlLXdpZHRoPSIzLjUyIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiLz4KPHBhdGggZD0iTTEwMTIuODQgMjI3LjA5Nkw4NTEuNDc5IDk1NC4zMSIgc3Ryb2tlLXdpZHRoPSIzLjUyIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiLz4KPHBhdGggZD0iTTk1NC4xMDUgMjI3LjA5Nkw3OTIuNzMxIDk1NC4zMSIgc3Ryb2tlLXdpZHRoPSIzLjUyIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiLz4KPHBhdGggZD0iTTg5NS4zNTggMjI3LjA5Nkw3MzMuOTk4IDk1NC4zMSIgc3Ryb2tlLXdpZHRoPSIzLjUyIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiLz4KPHBhdGggZD0iTTgzNi42MjUgMjI3LjA5Nkw2NzUuMjY1IDk1NC4zMSIgc3Ryb2tlLXdpZHRoPSIzLjUyIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiLz4KPHBhdGggZD0iTTc3Ny44OTIgMjI3LjA5Nkw2MTYuNTE5IDk1NC4zMSIgc3Ryb2tlLXdpZHRoPSIzLjUyIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiLz4KPHBhdGggZD0iTTcxOS4xNDUgMjI3LjA5Nkw1NTcuNzg1IDk1NC4zMSIgc3Ryb2tlLXdpZHRoPSIzLjUyIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiLz4KPHBhdGggZD0iTTY2MC40MTIgMjI3LjA5Nkw0OTkuMDUyIDk1NC4zMSIgc3Ryb2tlLXdpZHRoPSIzLjUyIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiLz4KPHBhdGggZD0iTTEwODkuMDMgNDg1Ljk0OEgxMDYyLjY3TDExMjAuOTkgMjIzLjA4NkgxMTQ3LjM1TDEwODkuMDMgNDg1Ljk0OFoiLz4KPHBhdGggZD0iTTEwMzAuMjggNDg1Ljk0OEgxMDAzLjkyTDEwNjIuMjUgMjIzLjA4NkgxMDg4LjYxTDEwMzAuMjggNDg1Ljk0OFoiLz4KPHBhdGggZD0iTTk3MS41NDYgNDg1Ljk0OEg5NDUuMTg2TDEwMDMuNTIgMjIzLjA4NkgxMDI5Ljg4TDk3MS41NDYgNDg1Ljk0OFoiLz4KPHBhdGggZD0iTTkxMi44MTIgNDg1Ljk0OEg4ODYuNDUyTDk0NC43NzIgMjIzLjA4Nkg5NzEuMTMyTDkxMi44MTIgNDg1Ljk0OFoiLz4KPHBhdGggZD0iTTg1NC4wNzkgNDg1Ljk0OEg4MjcuNzE5TDg4Ni4wMzkgMjIzLjA4Nkg5MTIuMzk5TDg1NC4wNzkgNDg1Ljk0OFoiLz4KPHBhdGggZD0iTTc5NS4zMzMgNDg1Ljk0OEg3NjguOTczTDgyNy4zMDYgMjIzLjA4Nkg4NTMuNjY2TDc5NS4zMzMgNDg1Ljk0OFoiLz4KPHBhdGggZD0iTTczNi41OTkgNDg1Ljk0OEg3MTAuMjM5TDc2OC41NTkgMjIzLjA4Nkg3OTQuOTE5TDczNi41OTkgNDg1Ljk0OFoiLz4KPHBhdGggZD0iTTY3Ny44NjYgNDg1Ljk0OEg2NTEuNTA2TDcwOS44MjYgMjIzLjA4Nkg3MzYuMTg2TDY3Ny44NjYgNDg1Ljk0OFoiLz4KPHBhdGggZD0iTTYxOS4xMTkgNDg1Ljk0OEg1OTIuNzcyTDY1MS4wOTIgMjIzLjA4Nkg2NzcuNDUyTDYxOS4xMTkgNDg1Ljk0OFoiLz4KPC9nPgo8ZGVmcz4KPGNsaXBQYXRoIGlkPSJjbGlwMF81NTc5XzE2MDAzIj4KPHJlY3Qgd2lkdGg9IjExODAiIGhlaWdodD0iNjc0IiBmaWxsPSJ3aGl0ZSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPgo=";